import IconButton from '@material-ui/core/IconButton'
import DescriptionIcon from '@material-ui/icons/Description'
import EditIcon from '@material-ui/icons/Edit'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import FiberManualRecord from '@material-ui/icons/FiberManualRecord'
import { Text } from 'shared/components/Text/Text'
import { dividerGray, error, errorD1, white } from 'shared/theme/colors'
import styled, { css } from 'styled-components'

export const EmploymentHistoryItemWrapper = styled.div<{ $hasMarginBottom: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  ${(p) => (p.$hasMarginBottom ? `margin-bottom: 32px;` : '')}
  width: 100%;
`

export const EmploymentHistoryItemContainer = styled.div<{ $noBackgroundColor?: boolean; $isGap?: boolean }>`
  display: flex;
  flex-direction: row;
  border-radius: 6px;
  ${(p) => !p.$noBackgroundColor && `background-color: ${white};`}
`

export const EmploymentHistoryItemColumn = styled.div<{
  $alignItems?: 'flex-start' | 'flex-end'
  $middle?: boolean
}>`
  ${(p) =>
    p.$middle &&
    css`
      flex: 1;
      width: 100%;
    `}
  padding: 20px ${(p) => (p.$middle ? 0 : 24)}px 32px ${(p) => (p.$middle ? 0 : 32)}px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: ${(p) => p.$alignItems ?? 'flex-start'};

  @media (max-width: 480px) {
    padding: 20px ${(p) => (p.$middle ? 0 : 20)}px 20px ${(p) => (p.$middle ? 0 : 20)}px;
  }
`

export const EmploymentHistoryItemLineColumn = styled.div<{ $isGap?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  width: 40px;
  margin-right: 40px;

  ${(p) => p.$isGap && `margin-right: 0;`}
`

export const EmploymentHistoryItemLineVerticalLine = styled.div<{
  $dashed?: boolean
  $flex?: boolean
  $hidden?: boolean
}>`
  ${(p) => p.$flex && `flex: 1;`}
  min-height: 16px;
  width: 1px;
  display: inline-block;
  border-right: 1px ${(p) => (p.$hidden ? 'hidden' : p.$dashed ? 'dashed' : 'solid')} transparent;
  border-color: ${(p) => (p.$dashed ? errorD1 : dividerGray)};
`

export const EmploymentHistoryItemActions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`

export const EmploymentHistoryItemAction = styled.div<{ $justifyContent?: 'flex-start' | 'flex-end' }>`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: ${(p) => p.$justifyContent ?? 'flex-start'};
  ${(p) => p.onClick && 'cursor: pointer;'};
`

export const EmploymentHistoryItemMonthGapText = styled(Text)`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 24px 10px;
  color: ${errorD1};
  margin-right: 40px;
`

export const EmploymentHistoryItemIconButton = styled(IconButton)`
  padding: 4px;
`

export const EmploymentHistoryItemStyledErrorOutlineIcon = styled(ErrorOutlineIcon)`
  color: ${errorD1};
  background-color: ${error};
  padding: 1.5px;
  border-radius: 50%;
  font-size: 24px;
  position: relative;
  top: -2.5px;
  margin: 6.5px -11px 5.5px;
`

export const EmploymentHistoryItemStyledFiberManualRecord = styled(FiberManualRecord)`
  color: ${dividerGray};
  font-size: 16px;
  margin: 4px -8px 8px;
`

export const EmploymentHistoryItemStyledDescriptionIcon = styled(DescriptionIcon)`
  color: ${dividerGray};
  font-size: 16px;
  justify-self: start;
  margin: 0;
`

export const EmploymentHistoryItemStyledEditIcon = styled(EditIcon)`
  color: ${dividerGray};
  font-size: 16px;
  justify-self: end;
`
